<template>
  <b-container class="popup-native">
    <div class="d-block text-center popup-native__content">
      <Icon name="grStars" width="36" class="mb-2"/>
      <h1 class="title" v-if="title">{{ title }}</h1>
      <div class="position-relative">
        <div class="popup-native__text scroll mt-3">
          <div v-html="text" v-if="text"></div>
        </div>
        <div class="popup-native__blur" v-if="text"></div>
      </div>
    </div>
  </b-container>
</template>



<script>
export default {
  name: 'AppNativePopupWelcome',
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  computed: {
    title() {
      return this.data.title
    },
    text() {
      return this.data.text
    }
  }
}
</script>